export default __webpack_public_path__ + "static/media/eeg.2304f467.gif";